
export default {
  state: {
    id: null,
    email: null
  },
  mutations: {
    setUserId(state, id) {
      state.id = id
    },
    setUserEmail(state, email) {
      state.email = email
    }
  },
  actions: {
    auth({ commit }) {
      setTimeout(() => {
        commit('setUserId', 'test.user.id')
        commit('setUserEmail', 'test.user@example.com')
      }, 500);
    }
  },
  modules: {
  }
}
